import type { ApiConfig } from '@api/types';
import { typedMethodPost } from '@api/utils';
import type { ProductionOrderSearchResponseDto, PartSearchResponseDto } from '@api/generated/models';
import type { SearchProductionOrdersRequest, SearchPartsRequest } from './types';

// Domain types
import type { ProductionOrderSearchResponse, PartSearchResponse } from '@api/domain/types';

// Mappers
import { toProductionOrderSearchResponse, toPartSearchResponse } from '@api/domain/mappers';

export default ({ baseURL }: ApiConfig) => ({
  searchProductionOrders: typedMethodPost<
    SearchProductionOrdersRequest,
    ProductionOrderSearchResponseDto,
    ProductionOrderSearchResponse
  >(
    (data) =>
      fetch(`${baseURL}/v1/productionInformation/searchProductionOrders`, {
        method: 'POST',
        ...data,
      }),
    toProductionOrderSearchResponse
  ),
  searchParts: typedMethodPost<SearchPartsRequest, PartSearchResponseDto, PartSearchResponse>(
    (data) =>
      fetch(`${baseURL}/v1/search/parts`, {
        method: 'POST',
        ...data,
      }),
    toPartSearchResponse
  ),
});

// Re-export domain types for consumers
export type { ProductionOrderSearchResponse, PartSearchResponse };
export type { SearchProductionOrdersRequest, SearchPartsRequest } from './types';
